export const CLEARINGHOUSE_URL = 'https://crw.flclearinghouse.com/';

export const DCF_STATUS_OPTIONS = [
    { key: 'not eligible', value: 'not eligible', label: 'Not Eligible' },
    { key: 'screening in process', value: 'screening in process', label: 'Screening in Process' },
    { key: 'resubmission in process', value: 'resubmission in process', label: 'Resubmission in Process' },
    { key: 'agency review in process', value: 'agency review in process', label: 'Agency Review in Process' },
    { key: 'agency review required', value: 'agency review required', label: 'Agency Review Required' },
    { key: 'resubmission required', value: 'resubmission required', label: 'Resubmission Required' },
    {
        key: 'additional information requested from applicant',
        value: 'additional information requested from applicant',
        label: 'Additional Information Requested from Applicant',
    },
    { key: 'a new screening is required', value: 'a new screening is required', label: 'A New Screening is Required' },
];

export const STATUS_REQUIRING_REVIEW = ['agency review required', 'resubmission required'];

export const STATUSES_REQUIRING_EXPIRATION = [
    'agency review required',
    'agency review in process',
    'resubmission required',
    'resubmission in process',
];

export const REVIEW_NAMES: Record<string, string> = {
    'agency review required': 'Agency Review',
    'resubmission required': 'Resubmission',
};

export function dcfStatusLabel(value: string) {
    return DCF_STATUS_OPTIONS.find((option) => option.value === value)?.label ?? value;
}
